import React from "react";
import { useTable, useSortBy } from "react-table";
import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import Scrollbar from "../Scrollbar";
import useAuth from "../../hooks/useAuth";
import SeeBot from "../permissions/SeeBot";
import EditBot from "../permissions/EditBot";
import ArchiveBot from "../permissions/ArchiveBot";
import api from "../../net/api";
import InfoAccess from "../permissions/InfoAccess";

import { useTranslation } from "../../hooks/useLocalization";

const defaultPropGetter = () => ({});
const defaultRendererGetter = () => null;

const AdminBotsTable = ({
  id,
  columns,
  data,
  wheelPropagation,
  getColumnProps = defaultPropGetter,
  getRowProps = defaultPropGetter,
  getHeaderProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
  getCellRenderer = defaultRendererGetter,
  getCellRendererProps = defaultPropGetter,
}) => {
  const { t } = useTranslation();

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);

  const { checkRole } = useAuth();

  const showPermissions = (bot) => {

    return (
      <>
        <InfoAccess bot={bot} />
        {checkRole(api.ROLES.QA) && !(checkRole(api.ROLES.SUPER_ADMIN) || checkRole(api.ROLES.ADMIN)) && <SeeBot bot={bot} />}
        {(checkRole(api.ROLES.SUPER_ADMIN) || checkRole(api.ROLES.ADMIN)) && <EditBot bot={bot} />}
        {checkRole(api.ROLES.SUPER_ADMIN) && <ArchiveBot bot={bot} />}
      </>
    )
  }

  return (
    <div className="ps-dark ps-overflow-hidden">
      <Scrollbar wheelPropagation={wheelPropagation}>
        <Table bordered {...getTableProps()} id={id}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                style={{ borderTop: 0 }}
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps([
                      column.getSortByToggleProps(),
                      getColumnProps(column),
                      getHeaderProps(column),
                    ])}
                  >
                    {t(column.render("Header"))}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon icon={faSortUp} className="ms-2" />
                        ) : (
                          <FontAwesomeIcon icon={faSortDown} className="ms-2" />
                        )
                      ) : (
                        <FontAwesomeIcon icon={faSort} className="ms-2" />
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps(getRowProps(row))}>
                  {row.cells.map((cell) => {
                    if (cell.column.Header === "Actions") {
                      return (
                        <td {...cell.getCellProps([getCellProps(cell)])}>
                          {showPermissions(row.original)}
                        </td>
                      )
                    } else {
                      return (
                        <td {...cell.getCellProps([getCellProps(cell)])}>
                          {cell.render(
                            getCellRenderer(cell) || "Cell",
                            getCellRendererProps(cell)
                          )}
                        </td>
                      )
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Scrollbar>
    </div>
  );
};

export default AdminBotsTable;